import React from 'react';

import WatchlistButton from './WatchlistButton';
import WatchlistCheckbox from './WatchlistCheckbox';

import styles from './WatchlistSelection.css';

import Plus from '../../images/blue-plus.svg';
import Cross from '../../images/cross-icon.svg';

import { useWatchlistActionsApi } from '../../Hooks/useWatchlist';

const WatchlistSelection = ({
    closeModal = () => {},
    dispatchWatchlist = () => {},
    isAddFeature = false,
    isRemoveFeature = false,
    isModal = false,
    funds,
    watchlists = [],
    watchlistUuid: selectedWatchlistUuid = ''
}) => {
    const { createNewWatchlist } = useWatchlistActionsApi();

    return (
        <div className="modal-container" data-metrics-location="PU">
            {isModal && (
                <div className="modal-header">
                    <h3 className="modal-title">Watchlists</h3>
                    <input
                        alt="close"
                        className="close-icon"
                        onClick={() => closeModal()}
                        onKeyPress={() => closeModal()}
                        src={Cross}
                        type="image"
                    />
                </div>
            )}
            {watchlists.map(
                (watchlist, i) =>
                    isAddFeature || isRemoveFeature ? (
                        <WatchlistCheckbox
                            key={watchlist.watchlistUuid}
                            closeModal={closeModal}
                            dispatchWatchlist={dispatchWatchlist}
                            i={i}
                            funds={funds}
                            watchlist={watchlist}
                        />
                    ) : (
                        <WatchlistButton
                            key={watchlist.watchlistUuid}
                            watchlist={watchlist}
                            i={i}
                            selectedWatchlistUuid={selectedWatchlistUuid}
                            closeModal={closeModal}
                            dispatchWatchlist={dispatchWatchlist}
                        />
                    )
            )}
            <div className="modal-row modal-bottom-row">
                <button
                    data-metrics-type="DD"
                    className="add-new-button"
                    type="button"
                    onClick={() => {
                        createNewWatchlist(funds);
                    }}
                    onKeyPress={() => createNewWatchlist(funds)}
                >
                    <img alt="add-new" className="add-new-icon" src={Plus} />
                    <div className="new-text">New Watchlist</div>
                </button>
            </div>
            <style jsx>{styles}</style>
        </div>
    );
};

export default WatchlistSelection;
